import { api } from '../api';
import type { operations, UserSupportCase } from '../types';

type WithFile = { file: File | null };
type UserSupportFormArgs = operations['createUserSupportCase']['parameters']['path'] & UserSupportCase & WithFile;

export const supportFormApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    createUserSupportCase: builder.mutation<UserSupportCase, UserSupportFormArgs>({
      query: ({ account_pk, ...data }) => ({
        url: `api/account/${account_pk}/supportcase/`,
        method: 'POST',
        body: createFormData(data),
      }),
    }),
  }),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createFormData(args: any): FormData {
  const formData = new FormData();
  Object.keys(args).forEach((key) => {
    formData.append(key, args[key]);
  });
  return formData;
}
